import React, { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Flex, Modal } from 'antd';
import ImgGift from '@/shared/pictures/forecast_gift.png';
import { IMatch } from '../types';
import ImgClose from '@/shared/pictures/close.svg';

interface PropsGiftMatch {
  match: IMatch
  isActual:boolean
}

export const GiftMatch:FC<PropsGiftMatch> = observer(({match, isActual}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if(!isActual && !match.giftUrl && !match.giftDescription) return null;

  return (
    <>
      <div className="forecast-gift" onClick={()=>setIsModalOpen(true)}>
        <Flex vertical gap={12}>
          <p className='forecast-gift_title'>Возможный подарок</p>
          <p className='forecast-gift_text'>в случае вашей победы</p>
        </Flex>

        <img className='forecast-gift_icon' src={ImgGift} alt="icon" />
      </div>

      <Modal
        open={isModalOpen}
        footer={null}
        closeIcon={<img src={ImgClose} onClick={()=>setIsModalOpen(false)} alt=''/>}
      >
        <div className='modal'>
          <img src={match.giftUrl} className='modal_image' alt="img" />
          <p className='modal_title'>{match.giftName}</p>
          {
            match.giftDescription&& <p className='modal_text'>{match.giftDescription}</p>
          }
        </div>
      </Modal>
    </>
  );
});
